import { render, staticRenderFns } from "./Seccion4View.vue?vue&type=template&id=92042900&"
import script from "./Seccion4View.vue?vue&type=script&lang=js&"
export * from "./Seccion4View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports